<template>
    <div class="history-chart">
        <div class="content-1" style='height: 180px;'>
            <div class='chart-content-div-header'>
                <h4><small><i class="glyphicon glyphicon-calendar"></i>&nbsp;&nbsp;&nbsp;<span v-html='header'></span></small>
                <small><i v-on:click='exporting' style='float:right;' class='glyphicon glyphicon-print my-export'></i></small></h4>
            </div>
            <div class='chart-content-div'>
                <div v-bind:id="id"></div>
            </div>
        </div>
    </div>
</template>

<script>

let Highcharts = require('highcharts/highstock');
require('highcharts/modules/exporting')(Highcharts);

import { mapGetters } from 'vuex'

export default {
    name: 'history-chart',
    mounted(){
        this.chart = new Highcharts.stockChart(this.options)
    },
    watch: {
        data : function (value) {
            this.chart.series[0].setData(this.data)
            setTimeout(() => {
                this.setExtremes();
            }, 500);
        },
        period: function (value) {
            if (this.data) this.setExtremes();
        },
        year: function (value){
            if (this.data) this.setExtremes();
        }
    },
    methods:{
        exporting: function(){
            this.chart.exportChart();
        },
        setExtremes: function(){
            let current_date = new Date();
            let min;
            let max;
            if (this.year == current_date.getFullYear()) {
                
                if (this.period == 'AC') {
                    min = new Date(this.year, 0, 1);
                } else {
                    let date_aux = new Date(current_date);
                    min = new Date(date_aux.setMonth(date_aux.getMonth() - this.period));
                }
                max = current_date;
            } else {
                min = new Date(this.year, 0, 1);
                max = new Date(this.year, 11, 1);
            }

            setTimeout(() => {
                this.chart.xAxis[0].setExtremes(min.getTime(), max.getTime());
            }, 500)
        }
    },
    computed: {
        period() {
            return this.filters.period;
        },
        year() {
            return this.filters.year;
        },
        ...mapGetters(['filters'])
    },
    data(){
        return{
            chart: undefined,
            options: {
                chart: {
                    renderTo: this.id,
                    alignTicks: false,
                    height: 130,
                    borderColor: '#C9625F',
                    backgroundColor: 'transparent',
                    spacingTop: 0,
                    spacingBottom: 5,
                    spacingLeft: 0,
                    spacingRight: 0
                },
                rangeSelector: {
                    allButtonsEnabled: true,
                    selected: 4,
                    inputEnabled: false,
                      buttonTheme: {
                        fill: '#505053',
                        stroke: '#000000',
                        style: {
                            color: '#CCC'
                        },
                        states: {
                            hover: {
                                fill: '#707073',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            },
                            select: {
                                fill: '#000003',
                                stroke: '#000000',
                                style: {
                                    color: 'white'
                                }
                            }
                        }
                    },
                    inputBoxBorderColor: '#505053',
                    inputStyle: {
                        backgroundColor: '#333',
                        color: 'silver'
                    },
                    labelStyle: {
                        color: 'silver'
                    },
                    buttons: [{
                        type: 'month',
                        count: 3,
                        text: '3m'
                    }, {
                        type: 'month',
                        count: 6,
                        text: '6m'
                    }, {
                        type: 'ytd',
                        text: 'YTD'
                    }, {
                        type: 'year',
                        count: 1,
                        text: '1y'
                    }, {
                        type: 'all',
                        text: 'All'
                    }]
                },
                credits: {
                    enabled: false
                },             
                navigation: {
                    buttonOptions: {
                        enabled: false
                    }
                },
                scrollbar: {
                    enabled: false
                },
                navigator: {
                    enabled: false
                },
                // colors: ['rgba(128, 133, 233,0.8)'],
                colors: ['#6b91c9'],
                xAxis: {
                    minRange: 3,
                    lineColor: '#e1e1e1',
                    tickColor: '#EFEFEF',
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                        color: '#E0E0E3'
                        }
                    },
                },
                yAxis: {
                    gridLineColor: '#707073',
                    labels: {
                        style: {
                        color: '#E0E0E3'
                        }
                    },
                },
                series: [{
                    type: 'line',
                    name: this.typeValue,
                    dataGrouping: {
                        units: [[
                            'week', // unit name
                            [1] // allowed multiples
                        ], [
                            'month',
                            [1, 2, 3, 4, 6]
                        ]]
                    }
                }],
                tooltip: {
                    backgroundColor: 'rgba(0, 0, 0, 0.85)',
                    style: {
                        color: '#F0F0F0'
                    }
                },
                exporting: {
                    chartOptions:{
                        xAxis: {
                            lineColor: '#e1e1e1',
                            tickColor: '#EFEFEF',
                            labels: {
                                style: {
                                color: '#000'
                                }
                            },
                        },
                        yAxis: {
                            gridLineColor: '#e1e1e1',
                            labels: {
                                style: {
                                color: '#000'
                                }
                            },
                        }
                    }
                }
            },
            range_selector: 0,
        }
    },
    props: {
        data: {
            default: [],
            type: Array,
        },
        id: {
            type: String
        },
        typeValue: {
            type: String
        },
        header: {
            type: String
        }
    },
}

</script>

<style scoped>

.content-1 {
    background: #1E1E1E;
    border-radius: 0;
    border: 1px solid #E2E2E2;
    border: none;
    color: #5b5b5b;
    margin-bottom: 20px;
    min-height: 30px;
    position: relative;
    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.chart-content-div {
    padding: 5px 15px 1px;
}

.chart-content-div-header {
    padding: 8px 0 0 15px;
}

.chart-content-div-header h4{
    margin-top: -4px;
}

.chart-content-div-header h4 small{
    color: #ffffff;
}

.my-export{
    padding-right: 10px;
    cursor: pointer;
}


@media screen and (max-width: 420px) {
    .chart-content-div-header h4 small{
        font-size: 12px!important;
    }
    .my-export{
        padding-top:8px;
    }
    .chart-content-div-header h4 small{
        font-size: 12px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Components/History-chart.vue